import { useMemo, useState } from 'react';
import { SortDescriptor } from '@heroui/react';
import type { CdnItem } from '@/types';

export function useCdnSorting(cdns: CdnItem[]) {
  const [sortDescriptor, setSortDescriptor] = useState<SortDescriptor | undefined>(undefined);

  const sortedCdns = useMemo(() => {
    if (!sortDescriptor?.column) return cdns;

    return [...cdns].sort((a, b) => {
      let first: string;
      let second: string;

      switch (sortDescriptor.column) {
        case 'cdn_tag':
          first = a.cdn_tag.toLowerCase();
          second = b.cdn_tag.toLowerCase();
          break;
        case 'provider':
          first = (a.provider?.name || '').toLowerCase();
          second = (b.provider?.name || '').toLowerCase();
          break;
        case 'version':
          first = a.version || '';
          second = b.version || '';
          break;
        default:
          first = a.cdn_tag.toLowerCase();
          second = b.cdn_tag.toLowerCase();
      }

      const cmp = first < second ? -1 : first > second ? 1 : 0;
      return sortDescriptor.direction === 'descending' ? -cmp : cmp;
    });
  }, [cdns, sortDescriptor]);

  return {
    sortDescriptor,
    setSortDescriptor,
    sortedItems: sortedCdns,
  };
}
